"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.microEventListener = void 0;
const _1 = require(".");
function microEventListener(event, callback) {
    const mainEventName = `${_1.EVENT_NAME}-${event}`;
    const listener = (e) => {
        if (e.type !== mainEventName) {
            return;
        }
        const { eventName, payload } = e.detail;
        if (eventName === event) {
            callback(payload);
        }
    };
    window.addEventListener(mainEventName, listener);
    return {
        removeListener: () => window.removeEventListener(mainEventName, listener)
    };
}
exports.microEventListener = microEventListener;
//# sourceMappingURL=listener.js.map